module.exports = __webpack_public_path__ + "assets/img/app.27f93a58.png";